<template>
    <div>
        <div v-if="liga.bewerbe.length > 1" class="px-5">
            <v-radio-group v-model="selectedBewerb" row class="mt-0 pt-0">
                <v-radio v-for="bewerbTyp in meisterschaftBewerbe" :key="bewerbTyp.value"
                         :label="bewerbTyp.label" :value="bewerbTyp.value"
                ></v-radio>
            </v-radio-group>
        </div>
    </div>
</template>

<script>
export default {
    name: "meisterschaftBewerbSwitch",
    props: ['liga', 'meisterschaftBewerbe'],
    data: () => ({
        selectedBewerb: null,
    }),
    computed: {
        selectedBewerbParam() { return this.$route.query.bewerbTyp },
    },
    created(){
        this.setSelectedBewerb(this.$route.query.bewerbTyp)
    },
    methods: {
        setSelectedBewerb(to){
            this.selectedBewerb = to
        },
        routeSelectedBewerb(){
            if ( this.selectedBewerbParam && this.selectedBewerb &&
                this.selectedBewerb !== this.selectedBewerbParam ) {
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.bewerbTyp = this.selectedBewerb;
                this.$router.replace({path: p, query: q});
            }
        },
    },
    watch: {
        selectedBewerbParam(to){
            if ( to !== null && this.selectedBewerb !== to ) this.setSelectedBewerb(to)
        },
        selectedBewerb(to, from){
            if ( to !== this.selectedBewerbParam ) this.$emit('loadSelectedBewerb', to);
            if ( from !== null ) this.routeSelectedBewerb()
        },
    }
}
</script>

<style scoped>

</style>